import script from "./SearchBox.vue?vue&type=script&setup=true&lang=ts"
export * from "./SearchBox.vue?vue&type=script&setup=true&lang=ts"

import "./SearchBox.vue?vue&type=style&index=0&id=1568d00f&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1568d00f"]])

export default __exports__